import {
  SERVICE_REQUESTS_REQUEST,
  SERVICE_REQUESTS_SUCCESS,
  SERVICE_REQUESTS_FAILURE,
  SERVICE_REQUEST_DETAILS_REQUEST,
  SERVICE_REQUEST_DETAILS_SUCCESS,
  SERVICE_REQUEST_DETAILS_FAILURE,
  SERVICE_REQUEST_CREATE_REQUEST,
  SERVICE_REQUEST_CREATE_SUCCESS,
  SERVICE_REQUEST_CREATE_FAILURE,
  SERVICE_REQUEST_CREATE_NEW_REQUEST,
  SERVICE_REQUEST_CREATE_NEW_SUCCESS,
  SERVICE_REQUEST_CREATE_NEW_FAILURE,
  SERVICE_REQUEST_UPDATE_REQUEST,
  SERVICE_REQUEST_UPDATE_SUCCESS,
  SERVICE_REQUEST_UPDATE_FAILURE,
  SERVICE_REQUEST_STATUSES_REQUEST,
  SERVICE_REQUEST_STATUSES_SUCCESS,
  SERVICE_REQUEST_STATUSES_FAILURE,
  SERVICE_OUTCOME_STATUSES_REQUEST,
  SERVICE_OUTCOME_STATUSES_SUCCESS,
  SERVICE_OUTCOME_STATUSES_FAILURE,
  SERVICE_REQUEST_UPLOAD_FILES_REQUEST,
  SERVICE_REQUEST_UPLOAD_FILES_SUCCESS,
  SERVICE_REQUEST_UPLOAD_FILES_FAILURE,
} from './ServiceRequestManagerActions';

const initialState = {
  data: [],
  serviceRequest: {},
  error: null,
  isLoading: false,
  isUpdating: false,
  requestStatuses: null,
  outcomeStatuses: null,
  isFilesUploading: false,
};

export default function serviceRequestManagerReducer(
  state = initialState,
  { type, payload,  },
) {
  switch (type) {
    case SERVICE_REQUESTS_REQUEST:
      return { ...state, isLoading: true };
    case SERVICE_REQUESTS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        serviceRequest: {},
        error: null,
        isLoading: false,
      };
    case SERVICE_REQUESTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case SERVICE_REQUEST_DETAILS_REQUEST:
      return { ...state, isLoading: true };
    case SERVICE_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        serviceRequest: payload.data,
        error: null,
        isLoading: false,
      };
    case SERVICE_REQUEST_DETAILS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case SERVICE_REQUEST_CREATE_REQUEST:
      return { ...state, isUpdating: true };
    case SERVICE_REQUEST_CREATE_SUCCESS:
      return { ...state, serviceRequest: payload.data, errors: null, isUpdating: false };
    case SERVICE_REQUEST_CREATE_FAILURE:
      return { ...state, error: payload.error, isUpdating: false };

    case SERVICE_REQUEST_CREATE_NEW_REQUEST:
      return { ...state, isUpdating: true };
    case SERVICE_REQUEST_CREATE_NEW_SUCCESS:
      return { ...state, serviceRequest: payload.data, errors: null, isUpdating: false };
    case SERVICE_REQUEST_CREATE_NEW_FAILURE:
      return { ...state, error: payload.error, isUpdating: false };

    case SERVICE_REQUEST_UPDATE_REQUEST:
      return { ...state, isUpdating: true };
    case SERVICE_REQUEST_UPDATE_SUCCESS:
      return { ...state, serviceRequest: payload.data, errors: null, isUpdating: false };
    case SERVICE_REQUEST_UPDATE_FAILURE:
      return { ...state, error: payload.error, isUpdating: false };

    case SERVICE_REQUEST_UPLOAD_FILES_REQUEST:
      return { ...state, uploads: {}, isFilesUploading: true };
    case SERVICE_REQUEST_UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        uploads: payload.data,
        errors: null,
        isFilesUploading: false,
      };
    case SERVICE_REQUEST_UPLOAD_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFilesUploading: false,
      };

    case SERVICE_REQUEST_STATUSES_REQUEST:
      return { ...state, isLoading: true };
    case SERVICE_REQUEST_STATUSES_SUCCESS:
      return {
        ...state,
        requestStatuses: payload.data,
        error: null,
        isLoading: false,
      };
    case SERVICE_REQUEST_STATUSES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };

    case SERVICE_OUTCOME_STATUSES_REQUEST:
      return { ...state, isLoading: true };
    case SERVICE_OUTCOME_STATUSES_SUCCESS:
      return {
        ...state,
        outcomeStatuses: payload.data,
        error: null,
        isLoading: false,
      };
    case SERVICE_OUTCOME_STATUSES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/service-request-manager/ServiceRequestManagerReducer.js